import { render, staticRenderFns } from "./MainTabs.vue?vue&type=template&id=058ae846&scoped=true"
import script from "./MainTabs.vue?vue&type=script&lang=js"
export * from "./MainTabs.vue?vue&type=script&lang=js"
import style0 from "./MainTabs.vue?vue&type=style&index=0&id=058ae846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058ae846",
  null
  
)

export default component.exports